import { cn } from '@/shadcn-ui/utils';
import { colors } from '@/theme/colors';

export interface BannerErrorProps {
  className?: string;
}
export default function BannerError({ className }: BannerErrorProps) {
  return (
    <svg
      viewBox="0 0 30 38"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn(`h-[38px] w-[30px]`, className)}
    >
      <g filter="url(#filter0_d_3223_6918)">
        <rect
          x="9"
          y="7"
          width="16"
          height="24"
          rx="8"
          fill="url(#paint0_linear_3223_6918)"
        />
        <rect
          x="9.5"
          y="7.5"
          width="15"
          height="23"
          rx="7.5"
          stroke="#F3456E"
          strokeOpacity="0.952941"
          strokeMiterlimit="10"
        />
      </g>
      <g filter="url(#filter1_d_3223_6918)">
        <path
          d="M15.5936 14.4971C15.5429 13.6858 16.1872 13 17 13C17.8128 13 18.4571 13.6858 18.4064 14.4971L18.0624 20.0019C18.0273 20.563 17.5621 21 17 21C16.4379 21 15.9727 20.563 15.9376 20.0019L15.5936 14.4971Z"
          fill={colors.neutral100}
        />
      </g>
      <g filter="url(#filter2_d_3223_6918)">
        <circle cx="17" cy="24.5" r="1.5" fill={colors.neutral100} />
      </g>
      <defs>
        <filter
          id="filter0_d_3223_6918"
          x="0"
          y="0"
          width="30"
          height="38"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="-2" />
          <feGaussianBlur stdDeviation="3.5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.866667 0 0 0 0 0.00722222 0 0 0 0 0.00722222 0 0 0 0.4 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_3223_6918"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_3223_6918"
            result="shape"
          />
        </filter>
        <filter
          id="filter1_d_3223_6918"
          x="11.5908"
          y="11"
          width="10.8184"
          height="16"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="2" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_3223_6918"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_3223_6918"
            result="shape"
          />
        </filter>
        <filter
          id="filter2_d_3223_6918"
          x="11.5"
          y="21"
          width="11"
          height="11"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="2" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_3223_6918"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_3223_6918"
            result="shape"
          />
        </filter>
        <linearGradient
          id="paint0_linear_3223_6918"
          x1="11.5142"
          y1="11.4571"
          x2="25.4353"
          y2="20.7577"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E8194B" />
          <stop offset="1" stopColor="#F85A80" />
        </linearGradient>
      </defs>
    </svg>
  );
}
